import _ from "lodash";
import { DEMAND_SOURCE_TYPE } from "constants/DemandSources";

export function getFilteredLogsByRule(logs, rules) {
  const result = [];
  const ruleIds = _.map(rules, (rule) => rule.externalId);
  _.forEach(logs, (log) => {
    const ruleIdx = _.findIndex(ruleIds, (id) => id === log.entityId);
    if (ruleIdx >= 0) {
      result.push({
        ...log,
        entityName:
          rules[ruleIdx].uprName || rules[ruleIdx].name || log.entityName,
      });
    }
  });

  return result;
}

export function getDemandSourceType(demandSource) {
  if (_.isNil(demandSource)) {
    return DEMAND_SOURCE_TYPE.ALL;
  }

  if (_.isPlainObject(demandSource)) {
    return _.isEmpty(demandSource)
      ? DEMAND_SOURCE_TYPE.ALL
      : DEMAND_SOURCE_TYPE.SPECIFIC;
  }

  return null;
}
